module.exports = __webpack_public_path__ + "img/1_1-commerciale-negozio-0.8b125f1d.png";